import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import DraggableTableItems from "../../components/common/DraggableTableItems";
import { SavedIcon } from "../../StateManagment/SavedIcon";
import uuid from 'react-uuid'
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import Tooltip from "../../components/common/Tooltip";
import { useHistory } from "react-router-dom";
import { useState, useContext } from 'react';
import { useFirestoreAllOrderBy } from '../../firebase/useFirestore';
import { timestamp } from '../../firebase/config';
import { db } from '../../firebase/config';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { client } from "../../hooks/Client"

const AdminFunds = () => {
    // Context
    const [saved, setSaved] = useContext(SavedIcon)

    // State
    const [hoverIndex, setHoverIndex] = useState(null)
    const [placeholderIndex, setPlaceholderIndex] = useState(null);

     // Hooks
     const history = useHistory()

     // Firestore
     const funds = useFirestoreAllOrderBy('Funds', 'Position', 'asc')

    const addFund = () => {

        db.collection('Funds')
        .add({
            Name: 'Nieuw fonds',
            Sector: [],
            Region: [],
            ID: uuid(),
            Timestamp: timestamp,
            Position: funds.length + 1,
            OpenCall: 'Ja',
            Budget: 0,
            FINCode: 0,
            Context: '',
            ContactPerson: '',
            Email: '',
            Phone: '',
            Website: '',
            Description: '',
            SubmissionDeadline: '',
            Conditions: '',
            TargetGroup: [],
            Restrictions: '',
            ApplicationProcess: '',
            EvaluationProcess: ''
        })
        .then(() => {
            setSaved(true)
        })
    }

    const nameHandler = (e) => {

        const docid = e.target.dataset.docid
        const name = e.target.value

        db.collection('Funds')
        .doc(docid)
        .update({
            Name: name
        })
        .then(() => {
            setSaved(true)
        })

    }

    const deleteFund = (e) => {

        const docid = e.currentTarget.dataset.docid

        db.collection('Funds')
        .doc(docid)
        .delete()
        .then(() => {
            setSaved(true)
        })

    }

    const region = (region) => {

        if (region.includes('landelijk')) {
            console.log('landelijk')
            return 'Landelijk'
        }
    }

  return (
    <div className="main">
        <div className="main-container">
            <div className='page-header'>
                <AccountBalanceOutlinedIcon/>
                <h1>Fondsen beheer</h1>
            </div> 
            <div className="table-container dashboard-container">
                <div className='list-top-row-container'>
                    <Tooltip content={'Fonds toevoegen'} top='35px'>
                        <AddCircleOutlineOutlinedIcon onClick={addFund} />
                    </Tooltip>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>NAAM</th>
                            <th>DETAILS</th>
                            <th>VERWIJDEREN</th>
                        </tr>
                    </thead>    
                    {funds && funds.map((item, index) => (
                        <>
                            {placeholderIndex === index && (
                                <tr className="placeholder-row">
                                    <td className="secondary-table-cell"></td>
                                </tr>
                            )}
                            <DraggableTableItems 
                            item={item}
                            input={
                                <Tooltip content={item.Name} width='80%' right='-220px' top='-35px'>
                                    <input type="text" data-docid={item.docid} defaultValue={item.Name} placeholder='Naam' onChange={nameHandler}/>
                                </Tooltip>
                            }
                            parentIndex={index}
                            collection={'Funds'}
                            itemArray={funds}
                            setHoverIndex={setHoverIndex}
                            hoverIndex={hoverIndex}
                            title={item.Name}
                            setPlaceholderIndex={setPlaceholderIndex}
                            >
                            {/* <td>
                                {item.Sector}
                            </td>
                            <td>{region(item.Region)}</td>
                            <td>{item.TargetGroup}</td> */}
                            <td>
                                <SettingsOutlinedIcon className='table-delete-icon' onClick={() => history.push(`/${client}/fundBuilder/${item.ID}`)} />
                            </td>
                            <td>
                                <DeleteOutlinedIcon className='table-delete-icon' data-docid={item.docid} onClick={deleteFund} />
                            </td>
                            </DraggableTableItems>
                        </>
                    ))}
                </table>
            </div> 
        </div>
    </div>
  )
}

export default AdminFunds